import React from 'react'
import styled from 'styled-components/native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { NativeStackScreenProps } from '@react-navigation/native-stack'

import Checkout from 'APP/Components/Checkout'
import LogoHeader from 'APP/Components/LogoHeader'
import { ResponsiveView } from 'APP/Converse/Layout'

export const ScreenContainer = styled(SafeAreaView).attrs({
  edges: ['bottom', 'left', 'right'],
})`
  flex: 1
  background-color: ${({ theme }) => theme.colors.background};
`

const ContentContainer = styled(ResponsiveView)`
  gap: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

export type CheckoutScreenRouteProp = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  'checkoutScreen'
>

const CheckoutScreen = ({ route }: CheckoutScreenRouteProp) => {
  const { title, subtitle, ...checkoutParams } =
    route.params as ReactNavigation.RootParamList['checkoutScreen']

  return (
    <ScreenContainer>
      <ContentContainer>
        <LogoHeader title={title} subtitle={subtitle} testID="CHECKOUT_SCREEN_HEADER" />

        <Checkout {...checkoutParams} />
      </ContentContainer>
    </ScreenContainer>
  )
}

export default CheckoutScreen
